// @flow

import deepcopy from "deepcopy";

const initialState = {
    isLoading:false,
    detailOfSurvey:{},
    surveyList :[],
    leadQuestionList:[],
};
export default function survey(state= initialState, action:any) {
    switch (action.type) {
        case 'GET_SURVEY_DATA_PENDING':
            return {...state, isLoading:true};
        case 'GET_SURVEY_DATA_FULFILLED':
            return {...state,detailOfSurvey:action.payload.data,isLoading:false,
                surveyList:action.payload.data.SurveryOption,leadQuestionList:action.payload.data.leadQuestionList};        
        case 'GET_SURVEY_DATA_REJECT':
            return {...state, isLoading:false,};  
        case 'SELECT_LEAD_OPTION': 
            var item = action.payload
            let leadQuestionList = [...state.leadQuestionList];
            const copyLeadObject = {
                ...leadQuestionList[item.index].leadOptionArrayList[item.i]
            }
            if(copyLeadObject.IsMandatorySelect){
                copyLeadObject.IsSelected = copyLeadObject.IsSelected
            }else{
                copyLeadObject.IsSelected = !copyLeadObject.IsSelected
            }
            leadQuestionList[item.index].leadOptionArrayList[item.i] = copyLeadObject
            return {...state,leadQuestionList:deepcopy(leadQuestionList)};  
        case 'SELECT_SURVEY_OPTION':
            var OptionKey = action.payload.OptionKey
            var optionList = []
            if(state.detailOfSurvey.IsSingleSelectionSurvey){
                optionList = deepcopy(state.detailOfSurvey.SurveryOption)
            }else{
                optionList = state.surveyList
            }
            for(var optItr=0;optItr<optionList.length;optItr++){
                if(OptionKey == optionList[optItr].OptionKey){
                optionList[optItr].IsSelected =  !optionList[optItr].IsSelected
                }
            }
            return {...state,surveyList:deepcopy(optionList)};   
        case 'EDITABLE_LEAD_QUESTION_OPTION':
            var id = action.payload.id
            var value = action.payload.value
            var optionList = []
            var list = deepcopy(state.leadQuestionList);
            for(var surItr = 0 ; surItr<list.length;surItr++){
                var options = list[surItr].leadOptionArrayList
                for(var optItr=0;optItr<options.length;optItr++){
                    if(id == options[optItr].LeadOptionKey){
                        options[optItr].LeadOptionValue = value
                    }
                }
            }
            return {...state,leadQuestionList:deepcopy(list)};    
        case 'SUBMIT_SURVEY_OPTION_PENDING':
            return {...state,  isLoading:true,};
        case 'SUBMIT_SURVEY_OPTION_FULFILLED':
            return {...state, isLoading:false,};        
        case 'SUBMIT_SURVEY_OPTION_REJECT':
            return {...state, isLoading:false,};  
        case 'LOG_OUT':
            return state;
        default:
            return state;
    }
}
